import { useLocation, useSearchParams } from "react-router-dom";
import { Wordmark } from "@/shared/wordmark";
import { SignInForm } from "./components/signin-form";

export function SignIn() {
  const location = useLocation();
  const info = (location.state as { info?: string } | null)?.info;
  const invited = useSearchParams()[0].has("invite");

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <div className="w-full max-w-sm space-y-6">
        <div className="text-center space-y-3">
          <Wordmark />
          <h1 className="text-3xl font-normal tracking-[-0.03em]">Welcome to Kourai</h1>
          <p className="text-sm text-muted-foreground">
            {invited
              ? "Sign in with the invited address to join the workspace"
              : "Sign in or create an account"}
          </p>
        </div>

        {info && (
          <div className="rounded-md bg-primary/10 px-4 py-2 text-sm text-primary">{info}</div>
        )}

        <SignInForm />
      </div>
    </div>
  );
}
